import { forwardRef } from "react";
import RevealCard from "components/organisms/pregnancy/RevealCard";
import * as RevealCaptureCardStyles from "./RevealCaptureCard.styles";

const CONFETTI_PIECES = [
  { left: 55, top: 3, rotate: 25, color: "#4977ea" },
  { left: 76, top: 9, rotate: -20, color: "#ffcf00" },
  { left: 8, top: 12, rotate: 35, color: "#ff5086" },
  { left: 93, top: 13, rotate: -15, color: "#4977ea" },
  { left: 8, top: 27, rotate: 10, color: "#ffcf00" },
  { left: 91, top: 36, rotate: -30, color: "#ff5086" },
  { left: 21, top: 40, rotate: 40, color: "#ff5086" },
  { left: 79, top: 48, rotate: -25, color: "#ffcf00" },
  { left: 93, top: 67, rotate: 15, color: "#4977ea" },
  { left: 8, top: 68, rotate: -35, color: "#ffcf00" },
  { left: 18, top: 79, rotate: 20, color: "#4977ea" },
  { left: 68, top: 84, rotate: -10, color: "#ff5086" },
  { left: 34, top: 91, rotate: 30, color: "#ff5086" },
  { left: 84, top: 91, rotate: -40, color: "#4977ea" },
  { left: 12, top: 95, rotate: 5, color: "#ffcf00" },
  { left: 93, top: 98, rotate: -20, color: "#ffcf00" },
] as const;

// 공유/저장용 전체 화면 카드 (캡처 대상)
const RevealCaptureCard = forwardRef<
  HTMLDivElement,
  {
    imageUrl: string;
    date: string;
  }
>(({ imageUrl, date }, ref) => {
  return (
    <RevealCaptureCardStyles.StyledContainer ref={ref}>
      <RevealCaptureCardStyles.StyledConfettiLayer aria-hidden>
        {CONFETTI_PIECES.map((piece, index) => (
          <RevealCaptureCardStyles.StyledConfettiPiece
            key={`confetti-piece-${index}`}
            $left={piece.left}
            $top={piece.top}
            $rotate={piece.rotate}
            $color={piece.color}
          />
        ))}
      </RevealCaptureCardStyles.StyledConfettiLayer>

      <RevealCaptureCardStyles.StyledCardWrap>
        <RevealCard imageUrl={imageUrl} date={date} isCapture>
          <RevealCaptureCardStyles.StyledLogoImg
            src={require("assets/images/img_10M_logo_normal.png")}
            alt="열달후에 logo"
          />
        </RevealCard>
      </RevealCaptureCardStyles.StyledCardWrap>
    </RevealCaptureCardStyles.StyledContainer>
  );
});

export default RevealCaptureCard;
